<template>
  <div :class="['loading', { 'loading--visible': isLoaderVisible }]">
    <AttensiLoadingSpinner class="loading__spinner" />
    <div v-if="slotExists" class="loading__text">
      <slot />
    </div>
  </div>
</template>

<script>
import { AttensiLoadingSpinner } from '@attensi/materia'

/**
 * @deprecated - use BaseLoading component instead
 */
export default {
  components: {
    AttensiLoadingSpinner,
  },
  props: {
    delay: {
      type: Number,
      required: false,
      default: 200,
    },
  },
  data() {
    return {
      isLoaderVisible: false,
    }
  },
  computed: {
    slotExists() {
      return this.$slots.default
    },
  },
  mounted() {
    this.showLoader()
  },
  methods: {
    showLoader() {
      setTimeout(() => {
        this.isLoaderVisible = true
      }, this.delay)
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: none;
  flex-direction: column;
  align-items: center;
  gap: $spacing-3xs;

  &--visible {
    display: flex;
  }

  &__text {
    @include subtitle;
  }
}
</style>
